import React from "react";
import { motion } from "framer-motion";
import { Headphones, TrendingUp, Users } from "lucide-react";

const METRICS = [
  {
    Icon: Headphones,
    value: "۳ الی ۱۰ دلار",
    desc: "میانگین درآمد ارزی شما به ازای هر ۱,۰۰۰ بار شنیده شدن موزیک در پلتفرم‌های بین‌المللی.",
  },
  {
    Icon: TrendingUp,
    value: "۵۰۰ دلار",
    desc: "متوسط درآمد ماهانه هنرمندانی که به طور مستمر با ما همکاری می‌کنند.",
  },
  {
    Icon: Users,
    value: "+۱۵۰",
    desc: "مشتریان ما که هنرمندان مستقلی هستند که آثار خود را جهانی کرده‌اند.",
  },
];

export default function Stats() {
  return (
    <section id="stats" className="py-20 md:py-28 relative">
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 mx-auto w-[40rem] h-[40rem] bg-purple-600/15 blur-[160px] rounded-full pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight">
            اعداد و ارقامی که <span className="gradient-text-neon">قابل اعتماد</span> هستند
          </h2>
          <p className="mt-4 text-slate-300 leading-relaxed">
            عملکرد واقعی هنرمندانی که با ما همکاری می‌کنند، گواه شفافیت و اثربخشی مسیری است که با هم طی می‌کنیم.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {METRICS.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="relative glass glass-hover rounded-[2rem] p-8 overflow-hidden group transition-all"
              data-testid={`stat-card-${i}`}
            >
              <div className="absolute -top-16 -right-16 w-44 h-44 bg-gradient-to-br from-purple-500/25 to-cyan-400/15 blur-3xl rounded-full pointer-events-none transition-opacity duration-500 group-hover:opacity-100 opacity-70" />

              <div className="relative flex items-start justify-between gap-4">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-500/30 to-cyan-400/30 border border-white/10 flex items-center justify-center">
                  <m.Icon className="w-5 h-5 text-cyan-200" strokeWidth={1.7} />
                </div>
                <span className="text-[10px] uppercase tracking-widest text-slate-500">{`0${i + 1}`}</span>
              </div>

              <div className="relative mt-8">
                <div className="text-4xl md:text-5xl font-black gradient-text-neon leading-none" data-testid={`stat-value-${i}`}>
                  {m.value}
                </div>
                <p className="mt-4 text-sm text-slate-300 leading-relaxed">{m.desc}</p>
              </div>

              {/* decorative bottom line */}
              <div className="relative mt-6 h-px bg-gradient-to-l from-purple-500/40 via-cyan-400/30 to-transparent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
